import React from "react";

const CompanyIcon = ({
  activeColor = "#0f1560",
}: {
  activeColor?: string;
}) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Building with window and door cut-outs */}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 6C6 5.45 6.45 5 7 5H17C17.55 5 18 5.45 18 6V20H6V6ZM8.5 8H10.5V10H8.5V8ZM13.5 8H15.5V10H13.5V8ZM8.5 12H10.5V14H8.5V12ZM13.5 12H15.5V14H13.5V12ZM10.5 16.5H13.5V20H10.5V16.5Z"
      fill={activeColor}
    />
    {/* Ground */}
    <rect x="3" y="19.5" width="18" height="1.8" rx="0.9" fill={activeColor} />
  </svg>
);

export default CompanyIcon;
